<div class="modal-header">
  <h2 class="modal-title" mat-dialog-title>
    <span *ngIf="data.config" trans>Update text widget</span>
    <span *ngIf="!data.config">Add text widget</span>
  </h2>
  <button type="button" (click)="close()" class="close-button no-style" tabindex="-1">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>

<form (ngSubmit)="createOrUpdate()" [formGroup]="form" ngNativeValidate>
  <div mat-dialog-content class="many-inputs">
    <div class="input-container">
      <label for="text-widget-title" class="capitalize" trans>Title</label>
      <input cdkFocusInitial type="text" id="text-widget-title" formControlName="title" required/>
    </div>
  </div>

  <div class="input-container">
    <label for="text-widget-description" class="capitalize" trans>Description</label>
    <input type="text" id="text-widget-description" formControlName="description" />
  </div>

  <div class="buttons right" mat-dialog-actions>
    <button (click)="close()" type="button" mat-button class="button cancel cancel-button" trans>
      Cancel
    </button>
    <button
      type="submit"
      mat-raised-button
      color="accent"
      [disabled]="editor.loading$ | async"
      class="button primary submit-button"
    >
      <span *ngIf="data.config" trans>Update</span>
      <span *ngIf="!data.config" trans>Add</span>
    </button>
  </div>
</form>
